import React from "react";
import { Link } from "react-router-dom";

export function CTA({ to, href, onClick, children, testId, className = "", target }) {
  const content = (
    <>
      <span>{children}</span>
      <span className="arr" />
    </>
  );
  if (href) {
    return (
      <a
        data-testid={testId}
        href={href}
        onClick={onClick}
        target={target}
        rel={target === "_blank" ? "noreferrer" : undefined}
        className={`cta-link ${className}`}
      >
        {content}
      </a>
    );
  }
  if (to) {
    return (
      <Link data-testid={testId} to={to} onClick={onClick} className={`cta-link ${className}`}>
        {content}
      </Link>
    );
  }
  return (
    <button data-testid={testId} onClick={onClick} className={`cta-link ${className}`} type="button">
      {content}
    </button>
  );
}

export function Eyebrow({ children, className = "", testId }) {
  return (
    <div data-testid={testId} className={`eyebrow ${className}`}>
      {children}
    </div>
  );
}
